<section class="page">
  <header class="page-header">
    <div>
      <h1>Tillo brands</h1>
      <p>
        Set points earned per dollar for each gift-card brand. Purchase points =
        denomination × this rate × the user’s plan multiplier. Use 0 to award no points.
      </p>
    </div>
    <button
      class="btn btn-secondary"
      type="button"
      (click)="sync()"
      [disabled]="syncing() || loading()"
    >
      {{ syncing() ? 'Syncing…' : 'Sync from Tillo' }}
    </button>
  </header>

  @if (error()) {
    <div class="alert alert-error">{{ error() }}</div>
  }
  @if (success()) {
    <div class="alert alert-success">{{ success() }}</div>
  }

  <div class="filters">
    <input
      type="search"
      [(ngModel)]="searchName"
      placeholder="Search brand name"
      (keyup.enter)="search()"
    />
    <button class="btn btn-secondary" type="button" (click)="search()" [disabled]="loading()">
      Search
    </button>
  </div>

  <div class="panel">
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Brand</th>
            <th>Slug</th>
            <th>Currency</th>
            <th>Status</th>
            <th>Points per dollar</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @if (loading()) {
            <tr>
              <td colspan="7" class="muted">Loading…</td>
            </tr>
          } @else if (!rows().length) {
            <tr>
              <td colspan="7" class="muted">No Tillo brands found. Sync from Tillo to populate the catalogue.</td>
            </tr>
          } @else {
            @for (row of rows(); track row.id) {
              <tr>
                <td>
                  @if (row.logo_url) {
                    <img class="logo" [src]="row.logo_url" [alt]="row.name || 'Brand logo'" />
                  } @else {
                    <span class="logo-placeholder">—</span>
                  }
                </td>
                <td>{{ row.name || '—' }}</td>
                <td class="mono">{{ row.slug || '—' }}</td>
                <td>{{ row.currency || '—' }}</td>
                <td>
                  <span class="badge" [attr.data-status]="row.status === 1 ? 'active' : 'pending'">
                    {{ row.status === 1 ? 'active' : 'hidden' }}
                  </span>
                </td>
                <td>
                  <input
                    class="points-input"
                    type="number"
                    min="0"
                    step="0.01"
                    [ngModel]="drafts()[row.id]"
                    (ngModelChange)="onDraftChange(row.id, $event)"
                    (keyup.enter)="save(row)"
                  />
                </td>
                <td>
                  <button
                    class="btn btn-primary btn-sm"
                    type="button"
                    (click)="save(row)"
                    [disabled]="savingId() === row.id || !isDirty(row)"
                  >
                    {{ savingId() === row.id ? 'Saving…' : 'Save' }}
                  </button>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <div class="pager">
      <span class="muted">Page {{ page() }} of {{ pages() }} · {{ total() }} brands</span>
      <div class="pager-actions">
        <button
          class="btn btn-secondary"
          type="button"
          (click)="prev()"
          [disabled]="page() <= 1 || loading()"
        >
          Previous
        </button>
        <button
          class="btn btn-secondary"
          type="button"
          (click)="next()"
          [disabled]="page() >= pages() || loading()"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</section>
